import React from 'react';
import moment from 'moment';
import { FormSection } from '../../../components';
import { DatePickerField } from '@oforce/global-components';

export default function BulkDownloadDocumentsDateSelection({ formik }) {
  const updateFormikValues = activeOn => {
    const activeOnDate = activeOn.format(moment.HTML5_FMT.DATE);
    const { initialDocuments, initialData } = formik?.values;

    const filteredDocuments = initialDocuments
      ?.filter(document => document?.effectiveDate <= activeOnDate)
      ?.filter(document => !document?.expirationDate || document?.expirationDate > activeOnDate);

    const filteredDocumentIds = filteredDocuments?.map(document => document?.id);
    const insuredIds = initialData.filter(x => filteredDocumentIds.includes(x.documentId))?.map(x => x.insuredId);

    formik?.setFieldValue('documentIds', filteredDocumentIds);
    formik?.setFieldValue('documentIdsFilteredByDate', filteredDocumentIds);
    formik?.setFieldValue('documentsFilteredByDate', filteredDocuments);
    formik?.setFieldValue('insuredIdsFilteredByDate', insuredIds);
  };

  return (
    <FormSection title="Select Active Date for Documents">
      <DatePickerField
        name="activeOn"
        label="Active On"
        format="MM/DD/YYYY"
        fullWidth
        required
        allowClear={false}
        disabledDate={current => current && current > moment()}
        onChange={activeOn => updateFormikValues(activeOn)}
      />
    </FormSection>
  );
}
